export default Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  CARRIED: 'carried',
  LOST: 'lost',
  FAILED: 'failed',
  MAIN: 'main',
  DIVISION_CARRIED: 'division_carried',
  WITHDRAWN: 'withdrawn',
  HOLD: 'hold',
  PASSED: 'passed'
})



// WEBPACK FOOTER //
// ./src/enums/motion-state.js